import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHubLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 33,
	height: 31,
	viewBox: "0 0 33 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			opacity: .2,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 18.6788,
				height: 18.6788,
				rx: 9.33938,
				transform: "matrix(0.83205 0.5547 -0.830139 0.557556 16.6367 9.98633)",
				fill: "#9D2235"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .5,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 18.6791,
				height: 18.6791,
				rx: 9.33954,
				transform: "matrix(0.83205 0.5547 -0.830139 0.557556 16.6367 5.98438)",
				fill: "#9D2235"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_6967_101187)",
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 19.2471,
				height: 19.2471,
				rx: 9.62356,
				transform: "matrix(0.83205 0.5547 -0.830139 0.557556 16.6309 0)",
				fill: "#9D2235"
			}), /* @__PURE__ */ _jsx("g", {
				clipPath: "url(#clip1_6967_101187)",
				children: /* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M19.407 9.52379L21.7036 11.0549C21.8486 11.1515 21.9299 11.2831 21.9295 11.4206C21.929 11.5582 21.847 11.6904 21.7014 11.7882C21.5558 11.886 21.3585 11.9413 21.153 11.9421C20.9475 11.9429 20.7506 11.8891 20.6055 11.7924L19.4471 11.0201C19.1571 10.8267 18.7632 10.719 18.3522 10.7206C17.9411 10.7222 17.5466 10.8329 17.2554 11.0285L13.9611 13.2411C13.889 13.2895 13.8035 13.328 13.7094 13.3545C13.6153 13.3809 13.5145 13.3947 13.4128 13.3951C13.311 13.3955 13.2103 13.3824 13.1163 13.3567C13.0224 13.331 12.9371 13.2932 12.8653 13.2453L12.841 13.2291C12.696 13.1324 12.6147 13.0008 12.6151 12.8633C12.6156 12.7258 12.6976 12.5936 12.8432 12.4958L16.1395 10.2819C16.4307 10.0863 16.5948 9.82187 16.5957 9.54683C16.5965 9.27179 16.434 9.00865 16.144 8.81528L14.9835 8.04165C14.8385 7.94496 14.7573 7.81339 14.7577 7.67587C14.7581 7.53835 14.8401 7.40615 14.9857 7.30835C15.1314 7.21054 15.3286 7.15516 15.5341 7.15436C15.7396 7.15357 15.9366 7.20744 16.0816 7.30413L18.3883 8.84195C18.7126 8.44408 18.8192 7.98384 18.6895 7.54121C18.5599 7.09859 18.2021 6.70157 17.6786 6.41916C17.155 6.13676 16.4987 5.98682 15.8237 5.99542C15.1487 6.00401 14.4976 6.17059 13.9838 6.4662L13.8455 6.55907L9.58734 9.4353C9.2896 9.65229 9.12789 9.93726 9.136 10.2306C9.14412 10.5239 9.32145 10.8029 9.6309 11.0092C9.94035 11.2155 10.3579 11.3332 10.7964 11.3375C11.2348 11.3418 11.66 11.2326 11.9832 11.0325L14.6165 9.26385C14.6733 9.22023 14.7428 9.18481 14.8207 9.15979C14.8985 9.13477 14.9831 9.12068 15.0692 9.1184C15.1552 9.11612 15.241 9.1257 15.321 9.14654C15.401 9.16738 15.4737 9.19904 15.5345 9.23956C15.5952 9.28007 15.6428 9.32857 15.6743 9.38205C15.7057 9.43553 15.7203 9.49285 15.7172 9.55045C15.7142 9.60805 15.6934 9.66471 15.6563 9.7169C15.6192 9.7691 15.5665 9.81572 15.5016 9.85387L12.2032 12.0692C11.8852 12.2835 11.7061 12.5728 11.7052 12.8736C11.7043 13.1745 11.8816 13.4624 12.1984 13.6743L12.2227 13.6905C12.5403 13.9022 12.9715 14.0203 13.4216 14.0188C13.8717 14.0174 14.3039 13.8964 14.6234 13.6826L17.9197 11.4687C17.9764 11.425 18.0459 11.3896 18.1238 11.3646C18.2016 11.3396 18.2862 11.3255 18.3723 11.3232C18.4584 11.3209 18.5441 11.3305 18.6241 11.3514C18.7042 11.3722 18.7768 11.4039 18.8376 11.4444C18.8984 11.4849 18.9459 11.5334 18.9774 11.5869C19.0088 11.6403 19.0235 11.6977 19.0204 11.7553C19.0173 11.8129 18.9966 11.8695 18.9595 11.9217C18.9224 11.9739 18.8697 12.0205 18.8047 12.0587L16.1612 13.8342C15.8634 14.0512 15.7017 14.3361 15.7098 14.6295C15.718 14.9228 15.8953 15.2018 16.2047 15.4081C16.5142 15.6144 16.9318 15.732 17.3702 15.7364C17.8086 15.7407 18.2338 15.6314 18.557 15.4314L22.8415 12.5727C22.8415 12.5727 22.9676 12.4881 22.9778 12.4812C23.4269 12.1367 23.681 11.698 23.6951 11.2426C23.7092 10.7871 23.4825 10.3443 23.0549 9.99215C22.6273 9.64003 22.0263 9.40129 21.3581 9.31808C20.6899 9.23487 19.9974 9.31254 19.4029 9.53738L19.407 9.52379Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_6967_101187",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 19.2471,
				height: 19.2471,
				rx: 9.62356,
				transform: "matrix(0.83205 0.5547 -0.830139 0.557556 16.6309 0)",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_6967_101187",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 10.8265,
				height: 10.8265,
				fill: "white",
				transform: "matrix(0.83205 0.5547 -0.830139 0.557556 16.1406 5.01758)"
			})
		})] })
	]
});
export default SvgHubLogo;
